import React from 'react'
import InvoiceCustomerInfoForm from './common/invoiceCustomerInfoForm.component'
import InvoiceDeliveryAndDetailsForm from './common/invoiceDeliveryAndDetailsForm.component'
import InvoiceAttachmentsForm from './common/invoiceAttachmentsForm.component'
import InvoiceSent from './common/invoiceSent.component'
import InvoicedProducts from './common/invoicedProducts.component'

const InvoiceNewComponent = ({
  classes,
  step,
  goBack,
  goNext,
  formValues,
  updateFormValues
}) => {
  return (
    <>
      {step === 1 && (
        <InvoiceCustomerInfoForm
          classes={classes}
          goNext={goNext}
          formValues={formValues}
        />
      )}
      {step === 2 && (
        <InvoiceDeliveryAndDetailsForm
          classes={classes}
          goBack={goBack}
          goNext={goNext}
          formValues={formValues}
        />
      )}
      {step === 3 && (
        <InvoicedProducts
          classes={classes}
          goBack={goBack}
          goNext={goNext}
          formValues={formValues}
        />
      )}
      {step === 4 && (
        <InvoiceAttachmentsForm
          classes={classes}
          goBack={goBack}
          goNext={goNext}
          formValues={formValues}
          updateFormValues={updateFormValues}
        />
      )}
      {step === 5 && <InvoiceSent classes={classes} />}
    </>
  )
}
export default InvoiceNewComponent